import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export type ListRolesResponseItem = {
  id: string
  name: string
  permissions: Array<string>
  userCount: number
}

export const listRoles = async () => {
  const { body } =
    await api.get<ListRolesResponseItem[]>(`/users/roles/`)
  return body
}

export const useRoles = (
  enabled: MaybeRef<boolean> = true
) =>
  useQuery({
    queryKey: [ROLES_QUERY_KEY] as const,
    queryFn: listRoles,
    enabled,
  })
